import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { quoteFormSelector } from 'ctm-selectors';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';
import { spacingContactNumber } from '../beautify_contact_number';

const _ContactDetails = (props) => {
    const { email, firstName, lastName, contactNumber } = props;
    return (
        <QuoteCard title="Contact details" path="applicant_details">
            <QuoteQuestionPlainItem title="First and last name" content={`${firstName} ${lastName}`} />
            <QuoteQuestionPlainItem title="Email" content={email} />
            <QuoteQuestionPlainItem title="Contact number" content={spacingContactNumber(contactNumber)} />
        </QuoteCard>
    );
};

_ContactDetails.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string
};

const mapStateToProps = (state) => {
    const mobile = quoteFormSelector(state).getIn(['applicant', 'mobile']);
    const phone = quoteFormSelector(state).getIn(['applicant', 'phone']);
    return {
        firstName: quoteFormSelector(state).getIn(['applicant', 'firstName']) || '',
        lastName: quoteFormSelector(state).getIn(['applicant', 'lastName']) || '',
        email: quoteFormSelector(state).getIn(['applicant', 'email']),
        contactNumber: mobile || phone
    };
};

const ContactDetails = connect(mapStateToProps)(_ContactDetails);

export { ContactDetails, _ContactDetails };
